/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import * as yup from 'yup';

/* import { GlobalAuthContext, GlobalOperationContext } from 'store/context'; */

import { Row, Col } from "components/Grid";
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import SubTitle from "components/SubTitle";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import FileModal from "components/FileModal";
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import DialogComponent from 'components/ModalCancel';
import FilesAttachment from "components/FilesAttachment";

import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import StepNavigation from "components/StepNavigation/index";

//Mudar Conforme tela
export default function SendInvoice(props) {
  const [file, setFile] = useState();
  const [summary, setSummary] = useState({});
  const [endorsmentType, setEndorsmentType] = useState("");
  const authContext = useContext(GlobalAuthContext);

  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);

  const [historymsg, setHistorymsg] = useState([]);

  const [dialog, setDialog] = useState({ visible: false });

  function handleSummary() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json()).then(data => {
        console.log("Sumario-> ", data.ret_value)
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);
        setEndorsmentType(data.ret_value.endorsmentType)
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  };


  function handleSendApproval() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.paymentPackSendApproval(props.match.params.idOperation, formik.current.values.paymentPackMessage)
      .then(resp => resp.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        history.push(`/list`);

        //TODO: temporary
        //history.push(`/broking/payment-pack-approval/${props.match.params.idOperation}`)
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }



  function handleFile() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.paymentPackHtmlModal(props.match.params.idOperation)
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          setFile(resp.ret_value.paymentPackDocs)
        } else {
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
  };

  function handleMktCompostion() {
    history.push(`/broking/market-composition/${props.match.params.idOperation}`)
  };

  const goToLoginPage = () => {
    history.push('login');
  };


  useEffect(() => {
    loading.start();
    if (authContext.status !== true) {
      mc.error("Usuário não autenticado");

      goToLoginPage();
      return;
    }
    else {
      fitinsur.setAuthToken(authContext.token);

    };

    handleFile();
    handleSummary();
    loading.stop();
  }, [])


  function handleDialog() {
    setDialog({ visible: true })
  }

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
        <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} /> 
      <BrokingSummary data={summary} />

      <ContentCard title={'ENDORSEMENT - ANNIVERSARY: PREMIUM NOT PRE AGREED / PAYMENT PACK'}
        icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>

        <DialogComponent history={history} show={dialog.visible} setDialog={setDialog} idOperation={props.match?.params?.idOperation} />

        <Formik
          innerRef={formik}
          initialValues={{
            paymentPackMessage: ''
          }}
          onSubmit={handleSendApproval}
        >
          {formikProps => (
            <Form>
              <Row>
                <Col>
                  <Field
                    label={'Message'}
                    name={'paymentPackMessage'}
                    value={formikProps.values.paymentPackMessage}
                    onChange={(e) => formikProps?.setFieldValue('paymentPackMessage', e)}
                    component={TextField}
                  />
                </Col>
              </Row>

              <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
              <FilesAttachment signedDocs idOperation={props.match.params.idOperation}/>

              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>

                <ButtonContent>
                  <>
                    {endorsmentType ?
                      <Button
                        secundary
                        id="btnSubmitReject"
                        type="button"
                        onClick={e => handleDialog()}
                      >
                        CANCEL
                      </Button>
                      : null
                    }
                    <Button
                      style={{ marginLeft: "10px" }}
                      third
                      id="btnSubmitSend"
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleMktCompostion() }}
                    >
                      CDR
                    </Button>

                    <Button
                      style={{ marginLeft: "10px" }}
                      primary
                      type="submit"
                      id="btnSubmitSend"
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleSendApproval() }}
                    >
                      SEND APPROVAL
                   </Button>
                  </>
                </ButtonContent>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}